import { render, staticRenderFns } from "./About_Contact.vue?vue&type=template&id=583bb6b1&scoped=true"
import script from "./About_Contact.vue?vue&type=script&lang=js"
export * from "./About_Contact.vue?vue&type=script&lang=js"
import style0 from "./About_Contact.vue?vue&type=style&index=0&id=583bb6b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583bb6b1",
  null
  
)

export default component.exports